import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JwtModule } from '@auth0/angular-jwt';
import { NgbDateParserFormatter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';

import { CoreRouting } from './core.routing';
import { SharedModule } from '../shared/shared.module';
import { SystemMessageModule } from './system-message/system-message.module';
import { SystemMessageService } from './system-message/system-message-service';
import { LayoutModule } from './layout/layout.module';
import { HttpClientInterceptor } from './interceptors/http-client-interceptor';
import { TutorialHttpGuardInterceptor } from './interceptors/tutorial-http-guard.interceptor';
import { SpinnerService } from './layout/spinner/spinner.service';
import { SecurityService } from './security/security.service';
import { NavigationService } from '../shared/navigation/navigation.service';
import { NgbDateNativeParserFormatter } from '../shared/form-elements/components/date-picker/ngb-date-native-parser-formatter';
import { WebAuthnService } from './security/multi-factor-auth/web-authn.service';
import { InactivityTimeoutComponent } from './inactivity-timeout/inactivity-timeout.component';
import { InactivityTimeoutService } from './inactivity-timeout/inactivity-timeout.service';
import { GetPasswordComponent } from './security/get-password/get-password.component';
import { FilterSaveService } from '../shared/table/filter-save.service';
import { CollapsibleTableService } from './collapsible-table/collapsible-table.service';
import { PinAuthComponent } from './security/pin-auth/pin-auth.component';

export function getToken() {	
    if (localStorage.getItem('jwt') === null) { 
        document.cookie = 'JsonWebToken=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        return '';
    } 
    else { return localStorage.getItem('jwt')!; } //expire the cookie
}

/***
 * Contains application-wide, single use components and services.
 * Imported once (in the AppModule) when the app starts and never imported anywhere else.
*/
@NgModule({ 
    declarations: [
        ...CoreRouting.declarations
        , InactivityTimeoutComponent
        , GetPasswordComponent
        , PinAuthComponent
    ]
    , imports: [
        ...CoreRouting.imports
        , SystemMessageModule
        , LayoutModule
        , SharedModule
        , JwtModule.forRoot(
            {
                config: {
                    allowedDomains: [ globalThis.location.host ]
                    , tokenGetter: getToken
                }
            }
        )
    ]
    , exports: [
        ...CoreRouting.exports
        , SharedModule
        , LayoutModule
        , SystemMessageModule
    ]    
    , providers: [
        ...CoreRouting.providers
        , SystemMessageService
        , SpinnerService
        , SecurityService
        , WebAuthnService
        , InactivityTimeoutService
        , CollapsibleTableService
        , NavigationService
        , FilterSaveService
        , {
            provide: NgbDateParserFormatter
            , useClass: NgbDateNativeParserFormatter
        }
        , NgbDateNativeAdapter
        // FIRST, ahead of HttpClientInterceptor: a request refused during a guided walkthrough must
        // never increment the spinner count, have its URL rewritten, or reach the error handling
        // below it (S2N-3089 AC 52).
        , {
            provide: HTTP_INTERCEPTORS
            , useClass: TutorialHttpGuardInterceptor
            , multi: true
        }
        , {
            provide: HTTP_INTERCEPTORS
            , useClass: HttpClientInterceptor
            , multi: true
        }
        , provideHttpClient(withInterceptorsFromDi())
    ] 
})
export class CoreModule {}
